import React, { useState, useEffect } from 'react';
import { useRouter } from 'src/hooks/useRouter';
import SkeletonItems from 'src/components/organisms/events/SkeletonItems';

import Button from 'src/components/atoms/Button';
import MapButton from 'src/components/atoms/MapButton';
import EvvntHeader from 'src/components/organisms/EvvntHeader';
import NavBar from 'src/components/organisms/NavBar';
import BrandedFooter from 'src/components/organisms/BrandedFooter';
import EventsGrid from 'src/components/layout/EventsGrid';
import EventsContainer from 'src/components/layout/EventsContainer';
import Event from 'src/models/Event';
import { useSelector } from 'src/hooks/useSelector';
import CurrentStateTags from 'src/components/organisms/CurrentStateTags';
import SearchBar from 'src/components/organisms/SearchBar';
import { hasEmptyQuery } from 'src/utils/router';
import InfiniteScroll from './InfiniteScroll';
import FeaturedEventsSection from './FeaturedEventsSection';
import { arrayWithUniqueIds, combineArrays } from '../../../utils/arrayHelpers';

const Map = React.lazy(() => import('./Map'));
const EventsList = ({
  rawEvents,
  rawFeaturedEvents,
  rawEditorsPickEvents,
  category,
  apiLoading,
}) => {

  const router = useRouter();
  const routerLoading = apiLoading;
  const publisherSettings = useSelector((state) => state.publisherSettings);
  const isFramed = useSelector((state) => state.isFramed);
  const isTextSearch = !!router.query.query?.length;
  const [showMap, setShowMap] = useState(false);

  const allRawEvents = combineArrays(rawEvents, rawFeaturedEvents, rawEditorsPickEvents);

  const allEvents = arrayWithUniqueIds(
    allRawEvents.map((event) => new Event(event, publisherSettings))
  );

  const MapSection = () => (
    <>
      <div className="flex flex-row">
        <div className="flex-grow">
          {isTextSearch && (
            <div className="text-base font-semibold m-2">
              Search results for &quot;{router.query.query}&quot;
            </div>
          )}
          <CurrentStateTags />
        </div>
        <div className="flex-initial mr-2">
          <Button
            onClick={() => setShowMap(!showMap)}
            text="Close Map"
            cancel
            extraClasses="text-xs uppercase  whitespace-nowrap"
          />
        </div>
      </div>

      <Map events={allEvents} publisherId={publisherSettings.publisher.id} />
    </>
  );
  return (
    <div className="min-h-screenw-full text-gray-900 max-w-7xl m-auto">
      <EvvntHeader />
      <SearchBar category={category} />
      <NavBar />
      <main className="mt-0 w-full" id="main-container">
        <EventsContainer>
          {!routerLoading && showMap && <MapSection />}
          {routerLoading && (
            <EventsGrid>
              <SkeletonItems count={12} />
            </EventsGrid>
          )}
          {!routerLoading && !showMap && (
            <>
              <div className="text-left w-full relative z-10">
                <div className="flex flex-row">
                  <div className="flex-grow">
                    {isTextSearch && (
                      <div className="text-base font-semibold m-2">
                        Search results for &quot;{router.query.query}&quot;
                      </div>
                    )}
                    <CurrentStateTags />
                  </div>
                  <div className="flex-initial mr-2 hidden @md:block">
                    <MapButton onClick={() => setShowMap(!showMap)} />
                  </div>
                </div>
              </div>

              <div className={hasEmptyQuery(router) ? '@md:-mt-8' : ''}>
                <FeaturedEventsSection
                  rawFeaturedEvents={rawFeaturedEvents}
                  rawEditorsPickEvents={rawEditorsPickEvents}
                  category={category}
                />
                <InfiniteScroll
                  publisherSettings={publisherSettings}
                  initialRawEvents={rawEvents}
                />
                {!rawEvents.length && (
                  <div>
                    <div className="flex flex-grow h-16 mb-16 items-center justify-center">
                      <h2 className="font-semibold text-xl">No events match your search</h2>
                    </div>
                  </div>
                )}
              </div>
            </>
          )}
        </EventsContainer>
      </main>

      {isFramed || <BrandedFooter publisherSettings={publisherSettings} />}
    </div>
  );
};

export default EventsList;
